import PropTypes from 'prop-types'

export default function DivLeftAlign({children, className, ...props}) {
  return (
    <div className={`text-left mb-4 ${className ? className : ''}`} {...props}>
      {children}
    </div>
  )
}

DivLeftAlign.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.element.isRequired,
    PropTypes.node.isRequired
  ]),
  className: PropTypes.string
}